//var cb_amount_clean = Number(cb_amount.replace(/[^0-9\.\-]+/g,""));
/*
  cb amount
*/
/**
 * Desktop/Mobile CB amount Management (for some module specificities)
 */

//-- remove all modules tagged by  [data-nocbatall] which have a data-totalcb attribute set to 0
$("[data-nocbatall]").each(function() {
  var _module = $(this);

  //-- test if 0 cb
  if (_module.attr("data-totalcb") == "0") {
    if (_module.is("[class*=mob_]")){
      //-- nothing for now
    }
    //-- remove module from tree
    _module.remove();
  }
});
